/* eslint-disable max-len */
import React from "react";
import "react-bootstrap";
import { Link } from "react-router-dom";
import { copyTextToClipboard } from "../../common/Clipboard";
import ContactFormStateful from "./ContactFormStateful";
import { useTranslation } from 'react-i18next';

const GOOGLE_DIRECTIONS_URL = "https://www.google.com/maps/dir/?api=1&destination=Wypoczynkowa%2043%2C%2062-081%20Baranowo";
const BANK_ACCOUNT_NUMBER = "36 1140 2004 0000 3502 8025 8272";

const ContactPage = () => { const { t: tr } = useTranslation(); return (<div className="contact-page">
    <div className="row p-0 m-0 d-flex justify-content-center align-items-start">
      <div className="col-lg-5">
        <div className="contact-left-column pr-4 pl-4">
          <section className="contact-card">
            <h3 className="contact-card-title">{tr("public:contact_39")}</h3>
            <p>
              <i className="contact-icon fas fa-map-marker-alt"></i>
              Wypoczynkowa 43, 62-081 Baranowo
            </p>
            <p>
              <i className="contact-icon fas fa-phone"></i>
              (+48) 575 400 141
            </p>
            <p>
              <i className="contact-icon fas fa-envelope"></i>
              szkola@extra-english.pl
            </p>
            <p>
              <i className="contact-icon fas fa-clock"></i>{tr("public:openMondayFriday08002000_42")}</p>
          </section>

          <section className="contact-card">
            <h3 className="contact-card-title">{tr("public:writeToUs_43")}</h3>
            <p>{tr("public:leaveAMessageWeAreAlwaysHappyToHelp_44")}</p>
            <ContactFormStateful compact hideIntro />
          </section>

          <div className="contact-social-links">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.facebook.com/share/TcCBGmP6aFdLywZj/?mibextid=LQQJ4d"
              className="contact-social-link"
            >
              <i className="fab fa-facebook-f"></i>
              Facebook
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.instagram.com/extra_english.pl/"
              className="contact-social-link"
            >
              <i className="fab fa-instagram"></i>
              Instagram
            </a>
          </div>
        </div>
      </div>

      <div className="col-lg-5">
        <div className="contact-cards pr-4 pl-4 pl-lg-0">
          <section className="contact-card">
            <h3 className="contact-card-title">{tr("public:businessDetails_47")}</h3>
            <p>
              <i className="contact-icon fas fa-building"></i>
              NIP: 777-255-43-86
            </p>
            <p>
              <i className="contact-icon fas fa-building"></i>
              REGON: 300953920
            </p>
            <div className="bank-account-row">
              <span>{tr("public:bankAccount_50")}</span>
              <div className="bank-account-box">
                <strong>{BANK_ACCOUNT_NUMBER}</strong>
                <button type="button" onClick={() => copyTextToClipboard(BANK_ACCOUNT_NUMBER)}>{tr("public:copy_51")}</button>
              </div>
            </div>
            <small>{tr("public:pleaseNOTEIncludeTheChildsFirstAndLastName_52")}</small>
          </section>

          <section className="contact-card">
            <h3 className="contact-card-title">{tr("public:onlinePayments_53")}</h3>
            <div className="payment-card-intro">
              <i className="contact-icon far fa-credit-card"></i>
              <p>{tr("public:onlinePaymentsAreProcessedByAutopaySAAvailableMethods_54")}</p>
            </div>
            <img
              src="/resources/payment/autopay-blik-card-transfer-485x115.png"
              alt={tr("public:autopayBLIKCardPaymentsAndInstantBankTransfers_55")}
              className="autopay-payment-banner"
            />
            <small>{tr("public:extraEnglishDoesNotStorePaymentCardDetails_56")}</small>
          </section>

          <section className="contact-card">
            <h3 className="contact-card-title">{tr("public:documents_57")}</h3>
            <p>{tr("public:theRulesForPaymentsComplaintsCancellationAndRefundsAre_58")}{" "}
              <Link to="/terms">{tr("public:termsOfService_59")}</Link>.
            </p>
            <Link to="/payment" className="contact-document-link">
              <i className="far fa-credit-card"></i>
              <span>{tr("public:paymentDetails_60")}<small>{tr("public:paymentMethodsFulfilmentAndRefunds_61")}</small>
              </span>
            </Link>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="../../resources/offer/umowa_o_nauke_angielskiego_2026.pdf"
              className="contact-document-link"
            >
              <i className="far fa-file-alt"></i>
              <span>{tr("public:serviceAgreement_62")}<small>{tr("public:downloadPDF_63")}</small>
              </span>
            </a>
          </section>
        </div>
      </div>
    </div>

    <div className="row p-0 m-0 d-flex justify-content-center">
      <div className="col-lg-10">
        <div className="contact-map-section pr-4 pl-4">
          <div className="contact-map-heading">
            <h3 className="contact-card-title">{tr("public:findUs_64")}</h3>
          </div>
          <div className="contact-map google-maps embed-responsive embed-responsive-16by9">
            <iframe
              title="google-maps"
              className="embed-responsive-item"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2432.243909418292!2d16.792514416121623!3d52.438496250018154!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4704476481f3f1b9%3A0x1b85fc0a2ae42062!2sExtra+English!5e0!3m2!1sen!2suk!4v1566327647470!5m2!1sen!2suk"
              frameBorder="0"
            />
          </div>
          <div className="contact-map-footer">
            <span>
              <i className="contact-icon fas fa-map-marker-alt"></i>
              Extra English, Wypoczynkowa 43, 62-081 Baranowo
            </span>
            <a target="_blank" rel="noopener noreferrer" href={GOOGLE_DIRECTIONS_URL}>
              <i className="contact-icon fas fa-location-arrow"></i>{tr("public:getDirections_67")}</a>
          </div>
        </div>
      </div>
    </div>
  </div>); };

export default ContactPage;
